import { TableHead } from '@mui/material';

import { GDMTableHeadComponent } from './GDMTableHead.type';

/* TODO: Implement component using GDM default design */
const GDMTableHead: GDMTableHeadComponent = props => <TableHead {...props} />;

export default GDMTableHead;
